
import { FetchedAccountLoading } from '../actions/index';
import {
  call, put, takeEvery
} from 'redux-saga/effects';
import { getOrganizationTree } from '@axios/api.account';
import { getAccount } from '@axios/api.account';
import { FetchedOrgsTree, FETCHING_ORGS_TREE, FetchedAccount, FETCHING_ACCOUNT,FetchedLoginType,
  FetchedAccountTokenSuccess,
  UpdateRegisShow,
  ChangePwdShow
} from '@redux/actions'

import { RootStoreModel } from '../reducers';
import { ActionModel } from '@redux/models';
import { OrganizationNodepProps } from '@axios/models';


function* fetchingOrgsTreeEffect(action: ActionModel): Generator {

  const result: any = yield call(() => {
    return getOrganizationTree().then(res => {
      return res;
    }, err => {
      // console.log(err);
      return [];
    });
  });

  yield put(FetchedOrgsTree(result));
}

function* fetchingAccount(action: ActionModel): Generator {
  yield put(FetchedAccountLoading(true))
  const result: any = yield call(() => {
    return getAccount().then(res => {
      return res;
    }, err => {
      // console.log(err);
      return [];
    });
  });
  //console.log("fetchingAccount", result)
  if(!result.role)
  {
    yield put(FetchedAccountLoading(false))
    return;
  }
  if(result.isInitialPassword)
  {
    yield put(ChangePwdShow(true))
  }
  var loginType = 0;
  if (!result.role) {
    loginType = 1
  } else if (result.role == "Init") {
    loginType = 2
  } else {
    loginType = 3
    yield put(FetchedAccountTokenSuccess());
  }
  if (loginType != 3) {
    yield put(UpdateRegisShow(true))
  }
  console.log("fetchingAccount-loginType", loginType)
  yield put(FetchedAccountLoading(false))
  yield put(FetchedAccount(result));
  yield put(FetchedLoginType(loginType));
}


/* 
function* fetchingAzureAdApplication(action: any) {
  const fullState = (yield select()) as RootStoreModel;
  const { userState } = fullState;
  const { applicationAccessToken } = userState;
  const access = action.payload;
  const { applicationObjId } = access;

  // const patchUrlResult = yield call(() => {
  //   addReplyUrl(applicationAccessToken, applicationObjId, replyUrl)
  //     .then(res => {
  //       console.log(res);
  //       return res;
  //     }, err => {
  //       console.log(err);
  //       return [];
  //     });
  // });

  const result = yield call(() => {
    return getAppication(applicationAccessToken, applicationObjId).then(res => {

      // console.log(res);
      return res.data;
    }, err => {
      // console.log(err);
      return [];
    });
  });

  yield put(GraphApplicatonFetched(result));
}

function* fetchingPartnerAppUserCredenial(action: any) {
  const fullState = (yield select()) as RootStoreModel;
  const { userState } = fullState;
  const { bindedApplication } = userState;
  const { id, appId } = bindedApplication;
  const payload = action.payload;
  const { secret, idToken, tenantId, ok, fail } = payload;

  const patchUrlResult = yield call(() => {
    return generateAppUserCredential(id, idToken, appId, secret, tenantId)
      .then(res => {
        // console.log(res);
        ok && ok();
        return res.data;
      }, err => {
        // console.log(err);
        fail && fail();

        return '';
      });
  });

  if (patchUrlResult) {
    yield put(PartnerAppUserCredentialFetched(patchUrlResult['access_token']));
  }

}
 */

function* userSaga() {
  yield takeEvery(FETCHING_ORGS_TREE, fetchingOrgsTreeEffect);
  yield takeEvery(FETCHING_ACCOUNT, fetchingAccount);
  /* yield takeEvery(Graph_application_fetching, fetchingAzureAdApplication);
  yield takeEvery(Partner_AppUserCredential_Fetching, fetchingPartnerAppUserCredenial); */
}

export default userSaga;